import { createSlice } from '@reduxjs/toolkit'
import { decodeJwt } from 'jose'

export const userSlice = createSlice({
  name: 'users',
  initialState: () => {
    const token = sessionStorage.getItem('token')
    let decryptedToken
    let payload

    if (token) {
      decryptedToken = token?.replace(':', '.')
      payload = decodeJwt(decryptedToken)
    }

    return {
      userId: payload?.id ? payload?.id : null,
      range: payload?.range ? payload?.range : null,
      token: decryptedToken || null,
      roles: payload?.roles ? payload?.roles : null
    }
  },
  reducers: {
    setUsers: (state, action) => {
      state.userId = action.payload.userId
      state.range = action.payload.range
      state.token = action.payload.token
      state.roles = action.payload.roles
    }
  }
}
)

export const { setUsers } = userSlice.actions

export default userSlice.reducer
